import { format } from 'date-fns';
import store from 'index';

import * as Util from 'PMDB/util/ConsumptionUtil.js';

import * as Mail from 'PMDB/util/MailUtil.js';

class MetadataOnSave {
    
    elements = {};

    constructor(elements = {}) {
        this.elements = { ...elements };
    }
    
	createAutofillNewsTVConsumption = (changedElements,apiConsumption) => {
		const kcds = changedElements.keyConsumptionData.split(',');
		const text = {
			de: [],
			en: []
		};
		
		kcds.forEach(kcd => {
			const elm = Util.findByKCD(apiConsumption, kcd);
			if(elm && elm.TextWLTP_1_pag && elm.TextWLTP_2_pag) {
				let strDE = elm.TextWLTP_1_pag;
				let strEN = elm.TextWLTP_2_pag;
				strDE = strDE.replaceAll('<sub>2</sub>','₂');
				strEN = strEN.replaceAll('<sub>2</sub>','₂');
                // remove strong tag
                strDE = strDE.replaceAll('<strong>','');
				strEN = strEN.replaceAll('<strong>','');
                strDE = strDE.replaceAll('</strong>','');
				strEN = strEN.replaceAll('</strong>','');
				strDE = strDE.replace('[StandHeute]',format(new Date(), 'MM/yyyy'));
				strEN = strEN.replace('[StandHeute]',format(new Date(), 'MM/yyyy'));
				text.de.push(strDE);
				text.en.push(strEN);
			}
		});
		
		return text;
	}
	
    onCorrectModelConsumption = (changedElements) => {
		const merged = { ...this.elements, ...changedElements };
		const apiConsumptionModels = store.getState().ui.apiConsumptionModels;
		const apiConsumption = store.getState().ui.apiConsumption;
		const decoded = Util.decodeKDC(apiConsumptionModels, apiConsumption, /*merged.consumptiondatakeys*/merged.keyConsumptionData);
		const ids = (merged.modelle_ids && merged.modelle_ids.split(';')) || [];
		
		for(let id in decoded) {
			if(!ids.includes(id)) {
				delete decoded[id];
			}
		}
        
		/*changedElements.consumptiondatakeys*/changedElements.keyConsumptionData = Util.encodeKCD(decoded);
        
        let kcds = changedElements.keyConsumptionData.split(',');
        const correct = [];
        kcds.forEach(kcd => {
            if(!correct.includes(kcd)) {
                correct.push(kcd);
            }
        });
        changedElements.keyConsumptionData = correct.join(',');
		
		// need to correct consumption data text for newstv
		const text = this.createAutofillNewsTVConsumption(changedElements,apiConsumption);
		changedElements.newstv_descriptionlong_de = text.de.join('\n');
		changedElements.newstv_descriptionlong_en = text.en.join('\n');
		
        return changedElements;
    }
	
	onConsumptionDataChange = (changedElements) => {
		// autofill consumtion data text for newstv
        let kcds = changedElements.keyConsumptionData.split(',');
        const correct = [];
        kcds.forEach(kcd => {
            if(!correct.includes(kcd)) {
                correct.push(kcd);
            }
        });
        changedElements.keyConsumptionData = correct.join(',');
        
		const apiConsumption = store.getState().ui.apiConsumption;
		const text = this.createAutofillNewsTVConsumption(changedElements,apiConsumption);
		changedElements.newstv_descriptionlong_de = text.de.join('\n');
		changedElements.newstv_descriptionlong_en = text.en.join('\n');
		
        return changedElements;
	}
    
    onPMStateChange = (changedElements) => {
        // need to set URLs automatically
        let metadata = {};
        //console.log(this.elements, changedElements);
        if(this.elements.hasOwnProperty("status") && changedElements.hasOwnProperty("status")) {
            //console.log(this.elements.published, changedElements.published);
            if(this.elements.status !== changedElements.status) {
                if(changedElements.status === "approved" || changedElements.status === "approved internal") {
                    console.log("---------Approved----------");
                    const merged = { ...this.elements, ...changedElements };
                    Mail.sendMail(merged);
                    
                    // set URLs if approved
                    metadata = {
                        url_en: "https://newsroom.porsche.com/en/pi/"+changedElements.id,
                        url_de: "https://newsroom.porsche.com/de/pi/"+changedElements.id
                    };
                }
            }
        }
        
        // remove id and lang after send
        delete changedElements.id;
        delete changedElements.lang;
        delete changedElements.email;
        
        return { ...changedElements, ...metadata };
    }
}

export default MetadataOnSave;


